import { render, staticRenderFns } from "./banking-account-form.vue?vue&type=template&id=6b9fb619&"
import script from "./banking-account-form.vue?vue&type=script&lang=js&"
export * from "./banking-account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports